import React, { Fragment, useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { Button, CircularProgress, IconButton } from "@mui/material";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Cancel,
  Delete,
  Category,
  DeleteForever,
} from "@mui/icons-material";

import PopUpModel from "components/Popup/PopUpModel";
import TemporaryDrawer from "components/TemporaryDrawer";
import SkeletonLoader from "components/Loader/SkeletonLoader";
import NotFoundComponent from "components/NotFoundComponent";
import noFoundImg from "../../assets/img/no-data-found.jpg";
import { DeskTopContainer } from "themes/Device";
import { MobileContainer } from "themes/Device";
import MobileTitle from "components/MobileTitle";
import SearchBarInput from "components/SearchBarInput";
import MobileCategory from "components/MobileCategory";
import { RESOURCE } from "common/constant";
import { ACTION } from "common/constant";
import RoleBasedGuard from "guards/RoleBasedGuard";
//context
import {
  useLayoutState,
  useLayoutDispatch,
  addCurrentScreenTitle,
} from "context/LayoutContext";
import AddEditPaymentType from "./AddEditPaymentType";
import {
  useDeletePaymentTypeMutation,
  usePaymentType,
  useBulkDeletePaymentTypeClassMutation
} from "hooks/react-query/usePaymentType";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import Label from "components/Label";
import CheckPermission from "guards/CheckPermission";
import { useDispatch } from "react-redux";
import { setPaymentTypeData } from "state/actions/api.action";

const PREFIX = 'PaymentTypeList';

const classes = {
  cardCategoryWhite: `${PREFIX}-cardCategoryWhite`,
  cardTitleWhite: `${PREFIX}-cardTitleWhite`,
  root: `${PREFIX}-root`,
  tabel: `${PREFIX}-tabel`,
  prioritybtn: `${PREFIX}-prioritybtn`,
  mobileCard: `${PREFIX}-mobileCard`,
  mobileCategoryCard: `${PREFIX}-mobileCategoryCard`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.cardCategoryWhite}`]: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },

  [`& .${classes.cardTitleWhite}`]: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontFamily: '"Oxygen", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },

  [`& .${classes.root}`]: {
    width: "100%",
  },

  [`& .${classes.tabel}`]: {
    margin: "10px",
    marginTop: "0",
    "& .MuiPaper-root": {
      padding: 10,
      paddingBottom: 0
    },
    "& tr": {
      height: 50,
      "& .MuiTableCell-root": {
        paddingLeft: "15px",
        fontSize: "14px !important",
      },
    },
  },

  [`& .${classes.prioritybtn}`]: {
    "& a:hover,& a:focus": {
      backgroundColor: "#FF5C93",
    },
    marginLeft: "5px",
    backgroundColor: "#FF5C93",
    color: "white",
  },

  [`& .${classes.mobileCard}`]: {
    padding: "2px",
    paddingBottom: '80px'
  },

  [`& .${classes.mobileCategoryCard}`]: {
    margin: '0 auto'
  }
}));

const PaymentTypeList = () => {
  const theme = useTheme();

  const { data: expenseCategoryDataList, loading: expenseCategoryLoader } =
    usePaymentType();
  const { mutate: deletePaymentType } = useDeletePaymentTypeMutation();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deletePaymentTypeId, setDeletePaymentTypeId] = useState(0);
  const [deletingBtnProcess, setDeletingBtnProcess] = useState(false);
  const [addEditDrawerShow, setAddEditDrawerShow] = useState(false);
  const [addEditPaymentTypeId, setAddEditPaymentTypeId] = useState(0);
  const [searchPaymentType, setSearchPaymentType] = useState("");
  const [filterPaymentTypeList, setFilterPaymentTypeList] = useState(
    [],
  );
  const dispatch = useDispatch();

  const history = useHistory();
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (layoutState?.currentScreenTitle !== "Payment Type") {
      addCurrentScreenTitle(layoutDispatch, {
        currentScreenTitle: "Payment Type",
      });
    }
    return () => {
      if (layoutState?.currentScreenTitle === "Payment Type") {
        addCurrentScreenTitle(layoutDispatch, { currentScreenTitle: "" });
      }
    };
  }, []);

  const deleteFoodCategoryData = (paymentTypeId) => {
    if (paymentTypeId > 0) {
      setDeletingBtnProcess(true);
      deletePaymentType(paymentTypeId);
      setDeletingBtnProcess(false);
      setDeleteModalShow(false);
    }
  };

  const addEditDrawerClose = () => {
    setAddEditDrawerShow(false);
    setAddEditPaymentTypeId(0);
  };

  const deleteData = (deleteid) => {
    setDeletePaymentTypeId(deleteid);
    setDeleteModalShow(true);
  };
  const editData = (editid) => {
    history.push({
      pathname: `/app/paymenttype/edit/${editid}`,
      state: {
        paymentTypeId: editid,
        backToMain: () => history.push(`/app/paymenttype`),
      },
    });
  };
  const addDrawerShow = () => {
    history.push({
      pathname: `/app/paymenttype/add`,
      state: {
        paymentTypeId: 0,
        backToMain: () => history.push(`/app/paymenttype`),
      },
    });
  };

  const clearTxt = () => {
    setSearchPaymentType("");
  };

  useEffect(() => {
    setFilterPaymentTypeList(expenseCategoryDataList);
    console.log(expenseCategoryDataList);
    if(expenseCategoryDataList && expenseCategoryDataList.length > 0)
    {
      dispatch(setPaymentTypeData(expenseCategoryDataList))
    }
  }, [expenseCategoryDataList]);

  useEffect(() => {
    if (searchPaymentType) {
      let filterCategoryList = expenseCategoryDataList?.filter(
        (item) =>
          item.name &&
          item.name
            ?.toLowerCase()
            ?.includes(searchPaymentType.toLowerCase()),
      );
      setFilterPaymentTypeList(filterCategoryList);
    } else {
      setFilterPaymentTypeList(expenseCategoryDataList);
    }
  }, [searchPaymentType]);

  const { mutate: deleteBulkPaymentType } = useBulkDeletePaymentTypeClassMutation();
  const [bulkDeleteIds, setbulkDeleteIds] = useState([]);
  const [deletebulkPopupshow, setDeletebulkPopupshow] = useState(false);
  const handleDeleteRows = async () => {
    setDeletebulkPopupshow(false)
    setbulkDeleteIds([]);
    deleteBulkPaymentType({
      variables: {
        input: {
          ids: bulkDeleteIds
        },
      },
    });
  };
  const handleDeleteRowsConformation = async (event, rowData) => {
    const ids = rowData.map((d) => d.id);
    setDeletebulkPopupshow(true)
    setbulkDeleteIds(ids);
  };

  return (
    <Root>
      <DeskTopContainer>
        <div className={classes.tabel}>
          <MaterialTable
            title={
              <h5>
                <b className="ml-3">{"Payment Type"}</b>
              </h5>
            }
            columns={[
              {
                title: "Name",
                field: "name",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Code",
                field: "code",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Active",
                field: "active",
                cellStyle: {
                  width: "20%",
                },
              },
              {
                title: "Priority",
                field: "priority",
                cellStyle: {
                  width: "10%",
                },
              },
              {
                title: "Action",
                field: "action",
                cellStyle: {
                  width: "10%",
                },
                render: (rowData) => (
                  <Fragment>
                    <RoleBasedGuard
                      resource={RESOURCE.PAYMENT_TYPE}
                      action={ACTION.UPDATE}
                    >
                      <IconButton
                        color="primary"
                        title={"Edit Payment Type"}
                        aria-label={"Edit Payment Type"}
                        onClick={() => {
                          setAddEditPaymentTypeId(rowData.id);
                          setAddEditDrawerShow(true);
                        }}
                        size="large">
                        <EditIcon />
                      </IconButton>
                    </RoleBasedGuard>
                    <RoleBasedGuard
                      resource={RESOURCE.PAYMENT_TYPE}
                      action={ACTION.DELETE}
                    >
                      <IconButton
                        color="secondary"
                        title={"Delete Payment Type"}
                        aria-label={"Delete Payment Type"}
                        onClick={() => {
                          setDeletePaymentTypeId(rowData.id);
                          setDeleteModalShow(true);
                        }}
                        size="large">
                        <DeleteIcon />
                      </IconButton>
                    </RoleBasedGuard>
                  </Fragment>
                ),
              },
            ]}
            data={expenseCategoryDataList?.map((item, index) => {
              return {
                name: item.name,
                id: item.id,
                code: item.code,
                priority: item.priority,
                active: item?.is_active ? (
                  <>
                    <div>
                      <Label
                        variant={
                          theme.palette.mode === "light" ? "ghost" : "filled"
                        }
                        color={"success"}
                      >
                        {item?.is_active ? "Available" : item?.is_active}
                      </Label>
                    </div>
                  </>
                ) : (
                  <Label
                    variant={
                      theme.palette.mode === "light" ? "ghost" : "filled"
                    }
                    color={"error"}
                  >
                    {!item?.is_active ? "Unavailable" : item?.is_active}
                  </Label>
                ),
              }
            })}
            options={{
              paging: true,
              pageSize: 10,
              emptyRowsWhenPaging: false, //to make page size fix in case of less data rows
              pageSizeOptions: [10, 20, 30],
              sorting: true,
              selection: CheckPermission(RESOURCE.PAYMENT_TYPE, ACTION.DELETE) ? true : false,
              actionsColumnIndex: -1,
              searchFieldAlignment: "left",
              searchFieldStyle: { color: theme.palette.grey[500] },
              headerStyle: {
                color: theme.palette.grey[600],
                backgroundColor: theme.palette.grey[200],
              },
              // rowStyle: (rowData, index) => {
              //   if (index % 2) {
              //     return { backgroundColor: "#f2f2f2" };
              //   }
              // },
            }}
            actions={
              CheckPermission(RESOURCE.PAYMENT_TYPE, ACTION.DELETE) ? [
                {
                  icon: () => <DeleteForever />,
                  tooltip: "Delete Rows",
                  onClick: handleDeleteRowsConformation
                }
              ] : []
            }
            localization={{
              toolbar: {
                searchPlaceholder: t("search"),
              },
              body: {
                emptyDataSourceMessage: expenseCategoryLoader ? (
                  <SkeletonLoader />
                ) : (
                  <NotFoundComponent imgUrl={noFoundImg}>
                    <p style={{ fontWeight: 600 }}>
                      {"Payment Type Not found"}
                    </p>
                  </NotFoundComponent>
                ),
              },
            }}
            // other props
            components={{
              Toolbar: (props) => (
                <div className="custom-material-table-toolbar ">
                  <MTableToolbar {...props} />
                  <div style={{ padding: "0px 10px" }}>
                    <RoleBasedGuard
                      resource={RESOURCE.PAYMENT_TYPE}
                      action={ACTION.ADD}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        // onClick={addEditModelToggle}
                        startIcon={<AddCircleOutlineIcon />}
                        style={{ background: "", color: "#fff" }}
                        onClick={() => {
                          setAddEditDrawerShow(true);
                        }}
                      >
                        {"Add Payment Type"}
                      </Button>
                    </RoleBasedGuard>
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </DeskTopContainer>
      <MobileContainer>
        <div className={classes.mobileCard}>
          <MobileTitle
            resource={RESOURCE.PAYMENT_TYPE}
            title={"Payment Type"}
            addButton={addDrawerShow}
          />
          <SearchBarInput
            onChange={(e) => {
              setSearchPaymentType(e.target.value);
            }}
            value={searchPaymentType}
            placeholder={"Search"}
            clearTxt={clearTxt}
          />
          {expenseCategoryLoader ? (
            <SkeletonLoader count={3} height="10rem" />
          ) : (
            <div className={classes.mobileCategoryCard}>
              {filterPaymentTypeList &&
                filterPaymentTypeList.map((item, index) => (
                  <MobileCategory
                    resource={RESOURCE.PAYMENT_TYPE}
                    name={item.name}
                    active={item.is_active}
                    deleteData={deleteData}
                    editData={editData}
                    itemId={item?.id}
                    isMenuBar
                  />
                ))}
            </div>
          )}
        </div>
        {filterPaymentTypeList?.length < 1 && !expenseCategoryLoader && (
          <NotFoundComponent imgUrl={noFoundImg}>
            <p style={{ fontWeight: 600 }}>
              {"No Payment Type Found"}
            </p>
          </NotFoundComponent>
        )}
      </MobileContainer>
      <PopUpModel
        show={deleteModalShow}
        heading={"Payment Type Delete"}
        body={"Are you sure you want to delete Payment Type?"}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={() => setDeleteModalShow(false)}
            >
              {" "}
              <Cancel /> {t("popup-cancel-button-label")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => deleteFoodCategoryData(deletePaymentTypeId)}
            >
              {" "}
              <Delete />{" "}
              {deletingBtnProcess ? <CircularProgress /> : t("delete")}{" "}
            </Button>
          </>
        }
        onHide={() => setDeleteModalShow(false)}
      />
      <PopUpModel
        show={deletebulkPopupshow}
        heading={"Are you sure you want to delete selected Payment Type?"}
        body={"Please Conform Selected Opration."}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={() => setDeletebulkPopupshow(false)}
            >
              {" "}
              <Cancel /> {t("popup-cancel-button-label")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDeleteRows}
            >
              {" "}
              <Delete /> {t("delete")}{" "}
            </Button>
          </>
        }
        onHide={() => setDeletebulkPopupshow(false)}
      />
      <TemporaryDrawer
        drawerClose={addEditDrawerClose}
        isOpen={addEditDrawerShow}
        drawerWidth="50%"
        icon={<Category />}
        title={"Payment Type"}
      >
        <AddEditPaymentType
          paymentTypeId={addEditPaymentTypeId}
          drawerClose={addEditDrawerClose}
        />
      </TemporaryDrawer>
    </Root>
  );
};

export default PaymentTypeList;
